import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { AppSettings } from '../common/app.settings';
import 'rxjs/add/operator/map';

import { ContentHeaders } from '../common/headers';
import { QuizRun } from '../models/quiz.run.model';
import { ApiResult } from '../models/apiresult.model';

@Injectable()
export class QuizRunService {
    constructor(        
        private http: Http,
        private contentHeaders: ContentHeaders) {
    }

    getQuizRuns(): Promise<QuizRun[]> {
        // get users from api
        console.log('getQuizRuns');
        return this.http.get(AppSettings.apiEndPoint + '/QuizRun/GetQuizRuns', { headers: this.contentHeaders.headers })
            .map((response: Response) => {
                console.log(response);
                return response.json();
            })
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    getQuizRun(quizRunId: string): Promise<QuizRun> {
        return this.http.get(
            AppSettings.apiEndPoint + '/QuizRun/' + quizRunId,
            { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    updateQuizRun(quizRun: QuizRun): Promise<ApiResult> {
        return this.http.put(
            AppSettings.apiEndPoint + '/QuizRun/' + quizRun.id,
                JSON.stringify(quizRun),
                { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    addQuizRun(quizRun: QuizRun): Promise<ApiResult> {
        return this.http.post(
            AppSettings.apiEndPoint + '/QuizRun/',
                JSON.stringify(quizRun),
                { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    deleteQuizRun(questionGroupId: string): Promise<ApiResult> {
        return this.http.delete(
            AppSettings.apiEndPoint + '/QuizRun/' + questionGroupId,
            { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    private handleErrorPromise(error: any): Promise<void> {
        try {
            error = JSON.parse(error._body);
        } catch (e) {
        }

        const errMsg = error.errorMessage
            ? error.errorMessage
            : error.message
            ? error.message
            : error._body
            ? error._body
            : error.status
            ? `${error.status} - ${error.statusText}`
            : 'unknown server error';

        console.error(errMsg);
        return Promise.reject(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/quiz.run.service.ts